import axios from '../../../../Utils/Admin/axios.config'

export const ResetPasword = async (data) => {  
    var response = axios.post(`auth/reset/`,{"otp":data.otp,"password":data.pswd,"email":data.email}).then(res => {
        return res.data
    }).catch(err => { console.log(err) });
    return response
}